import { Skeleton } from "@commonlibs";

export default function ModifyMovementsSkeleton() {
    return (
        <div style={{ width: "100%", backgroundColor: "#fff", borderRadius: "8px", fontFamily: "sans-serif" }}> {/* skipcq: JS-0415 */}
            <div style={{ marginBottom: "24px" }}>
                <Skeleton style={{ marginBottom: "16px" }}>
                    <p>Selecciona el tipo rol</p>
                </Skeleton>
                <div style={{ display: "flex", gap: "24px" }}>
                    <Skeleton>
                        <p>Skeleton</p>
                    </Skeleton>
                    <Skeleton>
                        <p>Skeleton</p>
                    </Skeleton>
                    <Skeleton>
                        <p>Skeleton</p>
                    </Skeleton>
                </div>
            </div>

            <div style={{ display: "flex", gap: "24px", borderTop: "1px solid #eee", paddingTop: "24px" }}>
                <div style={{ width: "65%" }}>
                    <Skeleton style={{ marginBottom: "16px" }}>
                        <p>Tipo de operación</p>
                    </Skeleton>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                    </div>
                </div>

                <div style={{ width: "35%" }}>
                    <Skeleton style={{ marginBottom: "16px" }}>
                        <p>Selecciona el tipo rol</p>
                    </Skeleton>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxHeight: "200px", overflowY: "auto" }}>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                        <Skeleton>
                            <p>Skeleton item</p>
                        </Skeleton>
                    </div>
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                    borderTop: "1px solid #eee",
                    paddingTop: "24px",
                    marginTop: "24px",
                }}
            >
                <Skeleton
                    style={{
                        padding: "15px 20px",
                        width: "200px",
                        borderRadius: "20px",
                        border: "1px solid #ccc",
                        backgroundColor: "transparent",
                    }}
                >
                    <p>Skeleton</p>
                </Skeleton>
                <Skeleton
                    style={{
                        padding: "15px 20px",
                        width: "200px",
                        borderRadius: "20px",
                        border: "none",
                        backgroundColor: "#b0b0b0",
                        color: "#fff",
                    }}
                >
                    <p>Skeleton</p>
                </Skeleton>
            </div>
        </div>
    );
}
